/**
 * 微应用名称常量
 */
export enum APP_NAMES {
  DATA_CENTER = 'DataCenter',
  PAY_CENTER = 'PayCenter'
}

/**
 * ice-stark-data 共享数据 Key
 */
export const ICE_STORE_KEYS = {
  /** 共享的 Token key */
  BASIS_TOKEN: 'BASIS_TOKEN__',
  /** 共享的子系统lptoken key */
  LP_TOKEN: 'LP_TOKEN_ICE_MICRO_APP_',
  /** 结算系统微应用强制刷新状态 key */
  FORCE_RELOAD_LEYO_PAY: 'FORCE_RELOAD_FOR_MICRO_APP_LEYO_PAY'
}

/**
 * ice-stark-data 事件名称
 */
export const ICE_EVENT_NAMES = {
  RELOAD_APP_LEYO_PAY_CENTER: 'RELOAD_APP_LEYO_PAY_CENTER',
  /** 结算系统微应用路由变化事件 */
  ROUTER_CHANGE_LEYO_PAY_CENTER: 'ROUTER_CHANGE_LEYO_PAY_CENTER'
}
